import { Skeleton } from '@nextui-org/react'

import OrderAddressLoader from './components/OrderAddressLoader'
import OrderMetaLoader from './components/OrderMetaLoader'
import { OrderProductItemLoader } from './components/OrderProductItemLoader'
import OrderSummaryLoader from './components/OrderSummaryLoader'

export function OrderHistoryDetailLoader() {
  return (
    <div className="mx-auto grid w-full grid-cols-1 gap-10 divide-y border bg-white p-10 [&>*:not(:first-child)]:pt-10">
      <div className="relative space-y-3">
        <Skeleton className="w-1/5">
          <div className="h-5 w-1/5 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-3/5">
          <div className="h-6 w-3/5 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-4/5">
          <div className="h-3 w-4/5 bg-default-200"></div>
        </Skeleton>
        <Skeleton className="absolute right-0 top-0 w-20">
          <div className="h-5 w-20 bg-default-200"></div>
        </Skeleton>
      </div>
      <OrderMetaLoader />
      <div className="grid gap-10 md:flex md:justify-between">
        <OrderAddressLoader />
        <OrderAddressLoader />
      </div>
      <div>
        <OrderProductItemLoader />
        <OrderProductItemLoader />
      </div>
      <OrderSummaryLoader />
    </div>
  )
}

export default OrderHistoryDetailLoader
